import RA from 'ra-config'
import request from '../request'

const ROOT = RA.app.strategies.dataFolder

export function getStrategies() {
  return request(`${ROOT}/STRATEGY_AGG.json`)
}

export function getStrategySeries(id) {
  return request(`${ROOT}/STRATEGY_SERIES_${id}.json`, {
    initial: id
  })
}



// WEBPACK FOOTER //
// ./src/actions/strategies.js